<template>
   <div id="idEditarClienteExtraCostoModal">

        <ui-modal 
            ref="modal" 
            title="Editar Cliente Extra Costo"
            transition="scale-up"
            size="large"
            @close="actionSetShowModalEditClienteExtraCostoModal(false)"
        >
            <client-extra-cost-form 
                :ids = "ids"
                :closeModal = "cerrarModal"
            />
        </ui-modal> 

   </div>

</template>

<script>

    // UI Modal
    import UiModal from "keen-ui/src/UiModal";
    import { mapState, mapActions } from "vuex";
    import ClientExtraCostForm from '../clientesExtraCostos/ClientExtraCostForm.vue';
    // import DatePicker from "vue2-datepicker";
    // import NewDataTable from '../../../common/NewDataTable';

    export default {

        props: {
            ids  : { type: Array, default: () => [] },

        },
        data(){
            return {
                id_client : {},
                vigency: "",
                keys : { label: 'name', value: 'id' },
                id_container_type : {},
                id_extra_costos_tipo : {} ,
                id_currency : {},
                id_type_service_integral : {},

                data: [],
                checks: [],
                
                btnAction: false,

                comments: ""
            }
        },

        components: {
            UiModal,
            ClientExtraCostForm,
            // DatePicker,
            // NewDataTable
        },

        computed: {
            ...mapState("serviciosLogisticos", [
                "showModalEditClienteExtraCostoModal",
                "customersList",
                "listCarriers",
                "servicesTypeList",
                "clientsList",
                "listCurrencies",
                "extraCostTypes",
                "unityPayments",
                "containerTypes",
             ])
        },
        methods : {

            ...mapActions([ "ActionSetZindexTablaModal"]),

            ...mapActions("serviciosLogisticos",[
                "actionSetShowModalAgregarClienteExtraCostoModal",
                "actionSetShowModalEditClienteExtraCostoModal"
            ]),


            openModal(ref) {
                this.ActionSetZindexTablaModal(true);

                this.$refs[ref].open();
            },
            
            closeModal(ref) {
                this.$refs[ref].close();
                this.ActionSetZindexTablaModal(false);
            },
            cerrarModal(){
                this.closeModal('modal');
            },
            valid(){

                if( ! this.id_client.id ){
                    this.$vToastify.warning("Campo Cliente Obligatorio", "Alerta");
                    return false ;
                }
                return true ;
            },
            
          
        },
        watch: {
            showModalEditClienteExtraCostoModal: function( _new ){
                _new ? this.openModal("modal") : this.cerrarModal() ;
            }
        }

    }

</script>

<style>

#idEditarClienteExtraCostoModal .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 75% !important;
}
</style>